<template>
    <form class="mt-2" id="form-modal">
        {{ getDate }}
        <div class="form-group">
            <label class="label-form"  style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Status<span style="color: red">*</span>:</label>
            <b-skeleton-wrapper v-if="form_loader" b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton> 
            </b-skeleton-wrapper>
            <multiselect v-else :options="status"  placeholder='Select Organization Status' @input="updateStatus" :multiple="false"
                :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" 
                v-model="org_status" label="name" track-by="value" style="font-size:12px !important">
            </multiselect>

        </div>
        <div v-if="flag" class="form-group">

            <label class="label-form" style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Date<span style="color: red">*</span>:</label>
            <b-skeleton-wrapper v-if="form_loader" b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton> 
            </b-skeleton-wrapper>
            <input v-else class="form-control"  type="date" :min="min_date" v-model="date"/>


        </div>
        <div class="text-right">
          <button  class="btn btn-secondary ml-2 mr-2"  @click.prevent="cancel">Cancel</button>
          <button class="btn btn-default"  :style= "[miniLoading ? { 'padding-right' : '38px' } : { 'padding-right' : '12px' }]" @click.prevent="save">
            <font-awesome-icon v-if="miniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 25%; margin-top: 3px;" />
            Update</button>

        </div>
    </form>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import Multiselect from "vue-multiselect";
export default{
    components: {
      Multiselect,
    },
    props:['formData'],
    data: function() {
        return{
            form_loader:true,
            flag:false,
            miniLoading:false,
            org_status: [],
            org_data:[],
            date:"",
            min_date:"",
            status: [
                {name:"Active", value:1},
               {name:"Trial", value:2},
                {name:"Inactive", value:3},
                {name:"Warning", value:4},
            ],    
        }
    },
    computed:{
        getDate:function() {
            this.form_loader = true;
            this.date = "";
            this.min_date = new Date().toISOString().slice(0, 10);
            if(this.formData.org_status[0].value == 2 || this.formData.org_status[0].value == 4){
                this.flag = true;
                axios.get("admin/organization/check_trial_end_date?org_id=" + this.formData.org_id)
                .then((response) => {
                    let data = response.data.demo_url;
                    if (data != null) {
                        this.org_data = data;
                        this.date= this.org_data.trial_end_date?this.org_data.trial_end_date:"";
                        if(this.date){
                            this.min_date = this.date;
                        }
                    }
                    this.form_loader = false;
                });
            }else{
                this.form_loader = false;
                this.flag = false;
            }
            this.org_status=(this.formData.org_status.value == 2)? this.formData.trial_status: this.formData.org_status;
        },
    },
    // mounted:function(){ 
        
    // },
    methods:{
        updateStatus (){
            if(this.org_status.value == 4){
                this.flag = true;
            }else{
                this.flag = false;
                this.date = "";
            }
        },
        cancel(){
            window.$('#modal').modal('hide');
        },
        save(){
            this.miniLoading = true;
            if(this.org_status == [] || (this.org_status.value == 4 && this.date == "" )|| this.org_status.value == this.formData.org_status.value){
                if (this.org_status == [] ) {
                    this.$toast.warning('Status is required');
                }
                if (this.org_status.value == 4 && this.date  == "" ) {
                    this.$toast.warning('Warning date is required');
                }
                if(this.org_status.value == this.formData.org_status.value){
                    this.$toast.warning('Please update status');
                }
                this.miniLoading=false;
            }else{
                this.$store.dispatch("users/changeStatus", [this.org_status.value, this.formData.org_id,this.date])
                .then(() => {
                    this.$toast.success('Status has been updated successfully..');
                    this.miniLoading=false;
                    this.$store.dispatch('users/getAllOraganizations', [this.formData.page, this.formData.search,this.formData.tab]);
                    window.$('#modal').modal('hide');
                });
            }
        },
       
    }
}
</script>
<style>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 8px !important;
    right: 2%;
    width: auto;
}
</style>